"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");

var StrategyTypeEnum_1 = require("../../model/strategy/StrategyTypeEnum");
/**
 * Abstract {@link Strategy} converter.
 *
 * @author RV
 */


var AbstractStrategyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(AbstractStrategyConverter, _DataObjectConverter_);

  function AbstractStrategyConverter() {
    _classCallCheck(this, AbstractStrategyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(AbstractStrategyConverter).apply(this, arguments));
  }

  _createClass(AbstractStrategyConverter, [{
    key: "deserializeStrategyType",

    /**
     * Deserializes {@link StrategyTypeEnum type} of strategy.
     *
     * @param strategyDocument serialized strategy
     * @param conversions implementation of DataObjectConversions
     */
    value: function deserializeStrategyType(strategyDocument, conversions) {
      return conversions.asEnum(strategyDocument.strategyType, StrategyTypeEnum_1.StrategyTypeEnum);
    }
  }]);

  return AbstractStrategyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.AbstractStrategyConverter = AbstractStrategyConverter;